var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadTableAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8373_294118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#128B9B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.9C9.77614 17.9 10 18.1239 10 18.4V20.9C10 21.4523 10.4477 21.9 11 21.9H23C23.5523 21.9 24 21.4523 24 20.9V18.4C24 18.1239 24.2239 17.9 24.5 17.9C24.7761 17.9 25 18.1239 25 18.4V20.9C25 22.0046 24.1046 22.9 23 22.9H11C9.89543 22.9 9 22.0046 9 20.9V18.4C9 18.1239 9.22386 17.9 9.5 17.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6464 19.8536C16.8417 20.0488 17.1583 20.0488 17.3536 19.8536L20.3536 16.8536C20.5488 16.6583 20.5488 16.3417 20.3536 16.1464C20.1583 15.9512 19.8417 15.9512 19.6464 16.1464L17.5 18.2929V9.5C17.5 9.22386 17.2761 9 17 9C16.7239 9 16.5 9.22386 16.5 9.5V18.2929L14.3536 16.1464C14.1583 15.9512 13.8417 15.9512 13.6464 16.1464C13.4512 16.3417 13.4512 16.6583 13.6464 16.8536L16.6464 19.8536Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8373_294118",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8373_294118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8373_294118",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTableAction);
export default __webpack_public_path__ + "static/media/download-table-action.a3b029a75074f8917961518d2b609ff1.svg";
export { ForwardRef as ReactComponent };